




































































import { Component, Vue } from "vue-property-decorator";
import Sidebar from "../components/Sidebar.vue";
import { store, StoreState } from "../store";
import { mapState } from "vuex";
import * as moment from 'moment';    
import momentTZ from 'moment-timezone';
import RecordPlay from '../components/RecordPlay.vue';
import VueElementLoading from "vue-element-loading";



@Component({ 
  components: {
    Sidebar,RecordPlay,VueElementLoading
  },
  computed: {    
      ...mapState({
        user_image_url: (state: StoreState) => state.dashboard.user_image_url,
        voicemail_records: (state: StoreState) => state.reports.voicemail_records,
        userfirstname: (state: StoreState) => state.dashboard.userfirstname, 
        userlastname: (state: StoreState) => state.dashboard.userlastname,
        
    })
  }
})
export default class VoiceMail extends Vue { 
  data() {
    return {
    loader:false,
    vocemails:[],
    recordplay_modal:false,
    downloading_voiceid:null,
    spinIMG:'img/icons/spinn_icon.gif',
    show_delete_modal:false,
    no_history:false,
    vm_data:'',

    };
  }

  created() {
    this.$data.loader=true;
    this.$store.state.reports.voicemail_records=[];
    this.$store.dispatch("getVoicemails")
      .then(r =>
      {
      this.$data.loader=false;
      this.$data.no_history=(this as any).voicemail_records.length==0?true:false;
      })
      .catch(() => {
        this.$data.loader=false;
      });
  }

  togglemodel(data){
    this.$data.vm_data=data;
     this.$data.show_delete_modal=true; 
  }

  async delet_vm(){
    debugger
    var data=this.$data.vm_data
    await this.$store.dispatch('deleteVoicemail', {
      vm_id: data.media_id
     })
     .then(r =>
      {
          this.$data.show_delete_modal=false; 
          this.$store.dispatch("getVoicemails");
           
      });
  }

  timeStamp(timestmp) {
      return  moment((timestmp - 62167219200) * 1000).format("YYYY-MM-DD hh:mma");
  }

  duration(durtn) {
    const duration = momentTZ.duration(+durtn, 'seconds');
    return momentTZ.utc(duration.asMilliseconds()).format("mm:ss")
  }
    
  formatPhoneNumber(phoneNumber:string) {
	 if(typeof phoneNumber === "number") {
     phoneNumber = (phoneNumber as any).toString();
			}
				const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
				const matches = phoneNumber.match(re);
				if(matches === null) {
					console.log("The phone number " + phoneNumber + " could not be parsed");
						return "";
				}
				return `${matches[1]}- ${matches[2]}-${matches[3]}`;
  }
  async playVoicemail(data) {
		 try {
        let _vmattachment;
          await this.getvoicemailattachment(data).then(r => {
            _vmattachment=  r;
          });
          const audiourl=(_vmattachment as any).audiourl;
        var payload={
          timstamp:moment((data.timestamp - 62167219200) * 1000).format("YYYY-MM-DD hh:mma"),
          mediaUrl:audiourl
        }
         this.$data.recordplay_modal=true;
         this.$store.commit('SET_RECORDS_DATA' , payload)
        this.$props.voicemail.folder = 'saved';
        }
    catch {
        return;
    }
		
    }
    
  async getvoicemailattachment(data)
    {
      
      try {
        const voicemaildate = moment((data.timestamp - 62167219200) * 1000).format("YYYY-MM-DD hh:mma").split("-");; ;// (this as any).timeStamp.split("-");
        let m = voicemaildate[1];	
        let y= voicemaildate[0];
        var my= `${y}${m}`;
        const r = await this.$store.dispatch('getvoicemailaudioattachment',{media_id: data.media_id, my: my} );
        if(r) {
          const attachment= Object.keys(r.data._attachments)[0];
          const apiurl = r.data.APIServer;
          const dbname = r.data.dbname;
          const audiourl= `${apiurl}voicemailaudio/${dbname}/${data.media_id}/${attachment}`;
                return {
                  audiourl:audiourl,
                  attachment:attachment,
                };
          }
            }
      catch {
          return;
      }
    }

  play_record(media)
  {
    // alert(media.call_recording)
      var payload;
      if(media.type=="VM"){
        payload={
          call_recording:media.call_recording,
          timestamp:moment((media.timestamp - 62167219200) * 1000).format("YYYY-MM-DD hh:mma") //media.timeStamp
        }
        this.$emit('openModal', payload);
      }
      else{
        payload={
          call_recording:media.call_recording,
          timestamp:(this as any).timeStamp
          }
          this.$emit('openModal', payload);
        }
            //this.$emit('openModal', payload);
    }


    async downloadVoicemail(data ,indx)
		{
		//	this.downloading=true;
      let _vmattachment;
       this.$data.downloading_voiceid=indx;//data.id;// true;
			await this.getvoicemailattachment(data).then(r => {
						 	_vmattachment=  r;
       });
       this.$data.downloading_voiceid=null;// true;
			const audiourl=(_vmattachment as any).audiourl;
			const attachment=(_vmattachment as any).attachment;
			this.download_mycallrecord(audiourl,attachment);
    }
        
     download_mycallrecord(url, name) {  
      const fileurl= url;//this.$props.cdr.call_recording;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name); //or any other extension
      document.body.appendChild(link);
      link.click();
      // this.downloading=false;
        
      }

}
